var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort_box"},[_c('v-select',{attrs:{"items":_vm.list,"item-text":"text","item-value":"id","return-object":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }